import axiosConfig from './axios';

export {
    axiosConfig
}